import { Component, OnDestroy } from '@angular/core';
import {
  ReactiveFormsModule,
  Validators,
  NonNullableFormBuilder,
} from '@angular/forms';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { FormButtonComponent } from '../../../shared/components/form-controls/form-button/form-button.component';
import { TextInputComponent } from '../../../shared/components/form-controls/text-input/text-input.component';
import { DialogService } from '../../../core/services/dialog/dialog.service';
import { PasswordOtpComponent } from '../../../shared/components/dialogs/first-time-login/password-otp/password-otp.component';

@Component({
  selector: 'app-first-time-login',
  imports: [
    TranslateModule,
    ReactiveFormsModule,
    TextInputComponent,
    RouterLink,
    FormButtonComponent,
  ],
  templateUrl: './first-time-login.component.html',
  styleUrl: './first-time-login.component.scss',
})
export class FirstTimeLoginComponent implements OnDestroy {
  private readonly destroy$ = new Subject<void>();
  currentYear = new Date().getFullYear();
  firstTimeLogin = this.fb.group({
    email: [
      '',
      [Validators.required, Validators.minLength(3), Validators.maxLength(320)],
    ],
  });

  constructor(
    private readonly fb: NonNullableFormBuilder,
    private readonly dialogService: DialogService
  ) {}

  onSubmit(): void {
    this.dialogService.openDialog(
      PasswordOtpComponent,
      this.firstTimeLogin.value
    );
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
